import './Footer.css'
import logo from '../../assets/images/logo.jpg'
import Portfolio from '../../assets/images/Portfolio.jpg'
import { Link } from "react-router-dom";
import {FaGithubSquare ,FaLinkedin} from 'react-icons/fa'


const Footer = () => {
  return (
    <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top container footer">
      <div className="col-md-6 d-flex align-items-center">
        <Link to={'/account'} className=" text-muted text-decoration-none mx-2">
          <img src={logo} alt='logo' className='imgfooter'/>
        </Link>
        <span className="text-muted">rezk audi © 2023</span>
      </div>

      <ul className="nav col-md-4 justify-content-end list-unstyled d-flex text-center">
        <li className="ms-2 "><a href="https://Github.com/Rezkaudi/" target="_blank" rel="noopener noreferrer"><FaGithubSquare size={30}/></a></li>
        <li className="ms-2 "><a href="https://linkedin.com/in/rezk-audi-987499267/" target="_blank" rel="noopener noreferrer"><FaLinkedin size={30}/></a></li>
        <li className="ms-2 "><a href="https://Rezkaudi.github.io/Portfolio/" target="_blank" rel="noopener noreferrer"><img src={Portfolio} alt='Portfolio' className='icon'/></a></li>
      </ul>
    </footer>

  )
}

export default Footer